import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useStickySafeNavigate } from '@equifinance/shared';
import Page from '../components/Page';

const ApprovedContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
  width:100%;
`;
const ApprovedContainerInner = styled.div`
  width:200px;
  height:200px;
`;
const ApprovedText = styled.p`${({ theme }) => `
  color:${theme.primary};
  font-size: ${theme.fontSize[11]};
  font-weight: ${theme.fontWeight.bold};
`}`;
const Icon = styled.i`${({ theme }) => `
  color:${theme.primary};
  font-size: 200px;
  font-weight: ${theme.fontWeight.bold};
`}`;

function Approved() {
  const { id } = useParams() as {id: string};

  const navigate = useStickySafeNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate(`/commitments/${id}`);
    }, 3000);
  }, []);

  return (
    <Page>
      <ApprovedContainer>
        <ApprovedContainerInner>
          <Icon className="mi-check" />
        </ApprovedContainerInner>
        <ApprovedText>Approved</ApprovedText>
      </ApprovedContainer>
    </Page>
  );
}

export default Approved;
